// extracted by mini-css-extract-plugin
export default {"pageTitle":"ConfirmEmailUI_pageTitle__RlFo4","inputControl":"ConfirmEmailUI_inputControl__RpOvR","errorBox":"ConfirmEmailUI_errorBox__bwFut","button":"ConfirmEmailUI_button__tgQER"};